import type { Route } from 'next';
import { EventCardType } from 'sections/Events/components/EventCard/EventCard.types';
export const eventsCardsData: EventCardType[] = [
  {
    id: 4,
    registrationUrl: 'https://assets-eur.mkt.dynamics.com/97490e54-fad8-444f-95d3-13ab26ee6605/digitalassets/standaloneforms/34a4ab24-c945-f011-877a-6045bde15d9b',
    pageUrl: '/events/members-meeting',
    isOnline: false,
    image: {
      desktopSrc: '/images/pages/Events/MembersMeeting/team-desktop.webp',
      tabletSrc: '/images/pages/Events/MembersMeeting/team-tablet.webp',
      mobileSrc: '/images/pages/Events/MembersMeeting/team-mobile.webp',
      alt: 'Digital Freight Members',
    },
    priority: true,
    date: {
      month: 'February',
      days: '19.02.2026',
    },
    heading: {
      value: 'Monthly Members Meeting',
      image: null,
      imageAlt: null,
    },
    details: {
      date: {
        icon: '/images/pages/Events/icon-calendar.svg',
        value: '19 February 2026',
      },
      country: {
        icon: '/images/pages/Events/icon-location.svg',
        value: 'Online meeting',
      },
    },
    buttonTitle: 'Register',
  },
  {
    id: 9,
    registrationUrl: `https://assets-eur.mkt.dynamics.com/97490e54-fad8-444f-95d3-13ab26ee6605/digitalassets/standaloneforms/b87261f7-d26e-f011-bec2-7ced8d46ffa8?readableEventId=DFA_Executive_Roundtable_Kuala_Lumpur_2025_Driving_Forwarding_Excellence_Through_Digital_Innovati544667778`,
    pageUrl: '' as Route,
    isOnline: false,
    image: {
      desktopSrc: '/images/pages/Events/kuala-desktop.webp',
      tabletSrc: '/images/pages/Events/kuala-tablet.webp',
      mobileSrc: '/images/pages/Events/kuala-mobile.webp',
      alt: 'DFA Exclusive Round Table',
    },
    priority: false,
    date: {
      month: 'September',
      days: '23.09.2025',
    },
    heading: {
      value: 'DFA Executive Roundtable – Kuala Lumpur 2025: Driving Forwarding Excellence Through Digital Innovation',
      image: null,
      imageAlt: null,
    },
    details: {
      date: {
        icon: '/images/pages/Events/icon-calendar.svg',
        value: '23 September 2025 - 10:00 AM – 14:00 PM',
      },
      country: {
        icon: '/images/pages/Events/icon-location.svg',
        value: 'Kuala Lumpur, Malaysia',
      },
      location: {
        url: 'https://www.google.com/maps/place/Mandarin+Oriental,+Kuala+Lumpur/@3.1557927,101.7119498,17z/data=!3m1!4b1!4m9!3m8!1s0x31cc37d40feb449f:0x5bb866cf36359c4a!5m2!4m1!1i2!8m2!3d3.1557927!4d101.7119498!16s%2Fm%2F0cv_2ys?entry=ttu&g_ep=EgoyMDI1MDgyNS4wIKXMDSoASAFQAw%3D%3D',
        value: 'Opal & Pearl, Level G, Mandarin Oriental Kuala Lumpur, Kuala Lumpur City Centre, 50088',
      },
    },
    buttonTitle: 'Register',
  },
  {
    id: 8,
    registrationUrl: `https://assets-eur.mkt.dynamics.com/97490e54-fad8-444f-95d3-13ab26ee6605/digitalassets/standaloneforms/8f882df9-986b-f011-b4cc-6045bddf6bc1?readableEventId=DFA_Executive_Roundtable_Manila_2025_Empowering_Forwarders_Through_Digital_Innovation2525113295`,
    pageUrl: '' as Route,
    isOnline: false,
    image: {
      desktopSrc: '/images/pages/Events/meeting-01-desktop.webp',
      tabletSrc: '/images/pages/Events/meeting-01-tablet.webp',
      mobileSrc: '/images/pages/Events/meeting-01-mobile.webp',
      alt: 'DFA Exclusive Round Table',
    },
    priority: false,
    date: {
      month: 'September',
      days: '2.09.2025',
    },
    heading: {
      value: 'DFA Executive Roundtable – Manila 2025: Empowering Forwarders Through Digital Innovation',
      image: null,
      imageAlt: null,
    },
    details: {
      date: {
        icon: '/images/pages/Events/icon-calendar.svg',
        value: '2 September 2025 - 10:00 AM – 14:00 PM',
      },
      country: {
        icon: '/images/pages/Events/icon-location.svg',
        value: 'Manila, Philippines',
      },
      location: {
        url: 'https://www.google.com/maps/place/Okada+Manila/@14.5151576,120.9814988,17z/data=!3m1!4b1!4m9!3m8!1s0x3397cc1be21135ef:0x8cb7cb6671d7f4e9!5m2!4m1!1i2!8m2!3d14.5151576!4d120.9814988!16s%2Fg%2F11c0yz7hkd?entry=ttu&g_ep=EgoyMDI1MDcyOS4wIKXMDSoASAFQAw%3D%3D',
        value: 'Okada Manila New Seaside Drive, Entertainment City, Parañaque City 1701, Metro Manila, Philippines',
      },
    },
    buttonTitle: 'Register',
  },
  {
    id: 7,
    registrationUrl: `https://www.df-alliance.com/blog/dfa-executive-roundtable-2025-conference-summary`,
    pageUrl: '' as Route,
    isOnline: false,
    image: {
      desktopSrc: '/images/pages/Events/meeting-desktop.png',
      tabletSrc: '/images/pages/Events/meeting-tablet.png',
      mobileSrc: '/images/pages/Events/meeting-mobile.png',
      alt: 'DFA Exclusive Round Table',
    },
    priority: false,
    date: {
      month: 'June',
      days: '24.06.2025',
    },
    heading: {
      value: 'DFA Executive Roundtable: Digital Innovation in Canadian Freight Forwarding',
      image: null,
      imageAlt: null,
    },
    details: {
      date: {
        icon: '/images/pages/Events/icon-calendar.svg',
        value: '24 June 2025 - 9:30 AM – 12:30 PM',
      },
      country: {
        icon: '/images/pages/Events/icon-location.svg',
        value: 'Toronto, Canada',
      },
      location: {
        url: 'https://www.google.com/maps/place/Hilton+Garden+Inn+Toronto+Airport/@43.6898857,-79.6090061,17z/data=!4m9!3m8!1s0x882b397813d20771:0x6eb8e7e6f9c47637!5m2!4m1!1i2!8m2!3d43.6898857!4d-79.6064312!16s%2Fg%2F1tqyg3w1?entry=ttu&g_ep=EgoyMDI1MDYxNi4wIKXMDSoASAFQAw%3D%3D',
        value: 'Trillium Ballroom, Hilton Garden Inn Toronto Airport, 3311 Caroga Drive, Mississauga, ON L4V 1A3',
      },
    },
    buttonTitle: 'More details',
  },
  {
    id: 6,
    registrationUrl: `https://www.theglobalfreightsummit.com/event/2024/regProcessStep1:09ce1b97-373a-42d2-bb5b-6db904974f39?rt=Y2OM2JipKUKQ_o7j_ZKkYQ`,
    pageUrl: '/events/global-freight-summit',
    isOnline: false,
    image: {
      desktopSrc: '/images/pages/Events/GlobalFreightSummit/gfs-2024-desktop.webp',
      tabletSrc: '/images/pages/Events/GlobalFreightSummit/gfs-2024-tablet.webp',
      mobileSrc: '/images/pages/Events/GlobalFreightSummit/gfs-2024-mobile.webp',
      alt: 'Global Freight Summit',
    },
    priority: false,
    date: {
      month: 'November',
      days: '18.11 - 20.11.2024',
    },
    heading: {
      value: 'Global Freight Summit 2024',
      image: null,
      imageAlt: null,
    },
    details: {
      date: {
        icon: '/images/pages/Events/icon-calendar.svg',
        value: '18 November 2024 - 20 November 2024',
      },
      country: {
        icon: '/images/pages/Events/icon-location.svg',
        value: 'Dubai, United Arab Emirates',
      },
      location: {
        url: 'https://www.google.com/maps/place/Expo+City+Dubai/@24.9608843,55.1506911,15z/data=!4m6!3m5!1s0x3e5f72d99893b4f9:0x53ca187a1bc8bfd5!8m2!3d24.9608843!4d55.1506911!16s%2Fg%2F11nn3rqztf?entry=ttu',
        value: 'Expo City',
      },
    },
    buttonTitle: 'Register',
  },
  {
    id: 5,
    registrationUrl: '#',
    pageUrl: '/blog/global-freight-summit-2023-by-dp-world-key-insights-and-impressions-from-dfa' as Route,
    isOnline: false,
    image: {
      desktopSrc: '/images/pages/Events/GlobalFreightSummit/containers-desktop.webp',
      tabletSrc: '/images/pages/Events/GlobalFreightSummit/containers-tablet.webp',
      mobileSrc: '/images/pages/Events/GlobalFreightSummit/containers-mobile.webp',
      alt: 'Global freight summit card',
    },
    priority: false,
    date: {
      month: 'November',
      days: '15.11 - 17.11.2023',
    },
    heading: {
      value: 'Global Freight Summit 2023',
      image: null,
      imageAlt: null,
    },
    details: {
      date: {
        icon: '/images/pages/Events/icon-calendar.svg',
        value: '15 November 2023 - 17 November 2023',
      },
      country: {
        icon: '/images/pages/Events/icon-location.svg',
        value: 'Dubai, United Arab Emirates',
      },
      location: {
        url: 'https://www.google.com/maps/place/Coca-Cola+Arena/@25.2043102,55.2628073,17z/data=!3m1!4b1!4m6!3m5!1s0x3e5f43db141ff4fd:0xd3ce726c8458af4c!8m2!3d25.2043102!4d55.2653822!16s%2Fg%2F11fl7q5rsc?entry=ttu&g_ep=EgoyMDI1MDkxNS4wIKXMDSoASAFQAw%3D%3D',
        value: 'Coca Cola Arena',
      },
    },
    buttonTitle: 'More details',
  },
  {
    id: 3,
    registrationUrl: '#',
    pageUrl: '/blog/global-freight-summit-2022-by-dp-world-key-insights-and-thoughts-from-df-alliance' as Route,
    isOnline: false,
    image: {
      desktopSrc: '/images/pages/Events/GlobalFreightSummit/dp-world-desktop.webp',
      tabletSrc: '/images/pages/Events/GlobalFreightSummit/dp-world-tablet.webp',
      mobileSrc: '/images/pages/Events/GlobalFreightSummit/dp-world-mobile.webp',
      alt: 'DP World logo',
    },
    priority: false,
    date: {
      month: 'November',
      days: '14.11 - 16.11.2022',
    },
    heading: {
      value: 'Global Freight Summit 2022',
      image: null,
      imageAlt: null,
    },
    details: {
      date: {
        icon: '/images/pages/Events/icon-calendar.svg',
        value: '14 November 2022 - 16 November 2022',
      },
      country: {
        icon: '/images/pages/Events/icon-location.svg',
        value: 'Dubai, United Arab Emirates',
      },
      location: {
        url: 'https://www.google.com/maps/place/Grand+Hyatt+Dubai/@25.2278443,55.3255064,17z/data=!4m19!1m9!3m8!1s0x3e5f5d46f88c69a3:0xbdd27b1c33c3af0d!2sGrand+Hyatt+Dubai!5m2!4m1!1i2!8m2!3d25.2281726!4d55.3279045!3m8!1s0x3e5f5d46f88c69a3:0xbdd27b1c33c3af0d!5m2!4m1!1i2!8m2!3d25.2281726!4d55.3279045!15sChFHcmFuZCBIeWF0dCBEdWJhaSIDiAEBWhMiEWdyYW5kIGh5YXR0IGR1YmFpkgEFaG90ZWyaASNDaFpEU1VoTk1HOW5TMFZKUTBGblNVUk5lRkJ0YjFwQkVBReABAA',
        value: 'Grand Hyatt',
      },
    },
    buttonTitle: 'More details',
  },
  {
    id: 2,
    registrationUrl: 'https://www.youtube.com/watch?v=fRpK-6Ck9AY&feature=youtu.be&ab_channel=DigitalFreightAlliancebyDPWorld',
    pageUrl: '/events/future-of-freight',
    isOnline: true,
    image: {
      desktopSrc: '/images/pages/Events/FutureOfFreight/conference-desktop.webp',
      tabletSrc: '/images/pages/Events/FutureOfFreight/conference-tablet.webp',
      mobileSrc: '/images/pages/Events/FutureOfFreight/conference-mobile.webp',
      alt: 'DF Alliance meeting',
    },
    priority: false,
    date: {
      month: 'July',
      days: '19.07.2022',
    },
    heading: {
      value: 'DFA Conference on Digitalization and the Future of Freight',
      image: null,
      imageAlt: null,
    },
    details: {
      date: {
        icon: '/images/pages/Events/icon-calendar.svg',
        value: '19 July 2022, 15:00 UTC+7 (GMT+7)',
      },
      country: {
        icon: '/images/pages/Events/icon-location.svg',
        value: 'Bangkok, Thailand',
      },
      location: {
        url: 'https://www.google.com/maps/contrib/112411754511611996893/place/ChIJDf7QWt2e4jAR9f2xgL5R6KM/@15.6608519,97.2845105,5z/data=!4m6!1m5!8m4!1e2!2s112411754511611996893!3m1!1e1',
        value: 'Venue - Marriott Marquis Queen’s Park',
      },
    },
    buttonTitle: 'Follow online',
  },
  {
    id: 1,
    registrationUrl: '#',
    pageUrl: '/events/1st-dfa-annual-conference',
    isOnline: false,
    image: {
      desktopSrc: '/images/pages/Events/AnnualConference/office-desktop.webp',
      tabletSrc: '/images/pages/Events/AnnualConference/office-tablet.webp',
      mobileSrc: '/images/pages/Events/AnnualConference/office-mobile.webp',
      alt: 'DP World Company',
    },
    priority: true,
    date: {
      month: 'March',
      days: '10.03. — 11.03.2022',
    },
    heading: {
      value: 'Digital Freight Alliance Annual Members Meeting',
      image: null,
      imageAlt: null,
    },
    details: {
      date: {
        icon: '/images/pages/Events/icon-calendar.svg',
        value: '10 March 2022 — 11 March 2022',
      },
      country: {
        icon: '/images/pages/Events/icon-location.svg',
        value: 'Dubai, United Arab Emirates',
      },
      location: {
        url: 'https://www.google.com.ua/maps/place/%D0%94%D1%83%D0%B1%D0%B0%D0%B9+-+%D0%9E%D0%B1%D1%8A%D0%B5%D0%B4%D0%B8%D0%BD%D0%B5%D0%BD%D0%BD%D1%8B%D0%B5+%D0%90%D1%80%D0%B0%D0%B1%D1%81%D0%BA%D0%B8%D0%B5+%D0%AD%D0%BC%D0%B8%D1%80%D0%B0%D1%82%D1%8B/@25.0620108,54.798968,8.4z/data=!4m5!3m4!1s0x3e5f43496ad9c645:0xbde66e5084295162!8m2!3d25.2048493!4d55.2707828?hl=ru',
        value: 'DP World Flow Pavilion at Expo 2020',
      },
    },
    buttonTitle: 'More details',
  },
];